import { useMutation, useQueryClient } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';

interface IDeleteVariables {
    organizationId: string;
    uploadedProFormaId: number;
}

const deleteUploadedProForma = async ({ organizationId, uploadedProFormaId }: IDeleteVariables): Promise<void> => {
    const response = await axiosInstance.delete(`${API_ENDPOINTS.UPLOADED_PRO_FORMA.DELETE(organizationId, uploadedProFormaId)}`);
    return response.data;
};

const useDeleteUploadedProForma = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteUploadedProForma,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['getUploadedProFormas'] });
        },
        onError: error => {
            console.error('Error deleting uploaded pro forma:', error);
        },
    });
};

export default useDeleteUploadedProForma;
